import {ButtonConfig} from '../../../../component/processPopup/ProcessPopup.types';
import {TFunction} from 'react-i18next';

const stepFields: Record<number, string[]> = {
    0: ['subscriptionType', 'subscriptionName', 'category'],
    2: [
        'prices',
        'ticketsAmount',
        'ticketsLimit',
        'credits',
        'realizations',
        'saleStartDate',
        'saleStartTime',
        'saleEndDate',
        'saleEndTime',
        'redemptionEndDate',
        'redemptionEndTime',
        'redemptionUpToPrice'
    ]
};

const REVIEW_STEP_INDEX = 3; // The last step where save button should appear

export const getSubscriptionStepButtons = (
    currentStep: number, 
    handleNext: () => void,
    handlePrevious: () => void,
    t: TFunction<'subscriptions'>,
    handleSave?: (values: any, assignEvents?: boolean) => Promise<void>,
) => {
    
    const validateStep = async (
        stepIndex: number,
        validateForm: () => Promise<any>,
        setTouched: (fields: Record<string, boolean>, shouldValidate?: boolean) => void
    ): Promise<boolean> => {
        const fieldsToValidate = stepFields[stepIndex];
        
        if(!fieldsToValidate || fieldsToValidate.length === 0) {
            return true;
        }
        
        const touchedFields = fieldsToValidate.reduce((acc, field) => {
            acc[field] = true;
            return acc;
        }, {} as Record<string, boolean>);
        
        setTouched(touchedFields);
        const stepErrors = await validateForm();
        
        return fieldsToValidate.every(field => !stepErrors[field]);
    };

    const getStepButtons = (
        validateForm: () => Promise<any>,
        setTouched: (fields: Record<string, boolean>, shouldValidate?: boolean) => void,
        values?: any
    ): ButtonConfig[] => {
        const buttons: ButtonConfig[] = [];
            
        // Add return button for all steps except the first one
        if(currentStep > 0) {
            buttons.push({
                text: t('return'),
                onClick: async () => {
                    handlePrevious();
                },
                show: true,
                position: 'left',
                className: 'white'
            });
        }

        // Add save button for the review step (last step)
        if(currentStep === REVIEW_STEP_INDEX && handleSave) {
            buttons.push({
                text: t('save'),
                onClick: async () => {
                    if(values) {
                        await handleSave(values);
                    }
                },
                show: true,
                className: 'white',
                position: 'right'
            });
            buttons.push({
                text: t('saveAndAssignEvents'),
                onClick: async () => {
                    if(values) {
                        await handleSave(values, true);
                    }
                },
                show: true,
                position: 'right'
            });
        } else {
            buttons.push({
                text: t('continue'),
                onClick: async () => {
                    const isValid = await validateStep(currentStep, validateForm, setTouched);
                    if(isValid) {
                        handleNext();
                    }
                },
                show: true,
                position: 'right'
            });
        }
        return buttons;
    };

    return {getStepButtons, validateStep};
};

